import { render, staticRenderFns } from "./ResourceSearchOverlay.vue?vue&type=template&id=a2b8409e&scoped=true"
import script from "./ResourceSearchOverlay.vue?vue&type=script&lang=js"
export * from "./ResourceSearchOverlay.vue?vue&type=script&lang=js"
import style0 from "./ResourceSearchOverlay.vue?vue&type=style&index=0&id=a2b8409e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b8409e",
  null
  
)

export default component.exports